<template>
    <section class="stealth-goal-achieved">
        <div class="grid-container">
            <div class="profile-label">
                Goal achieved
            </div>
        </div>

        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="goalAchievedList"
                    align="center"
                    data-qa="campaign-goal-table"
                >
                    <ds-table-grid-column
                        label="Id"
                        width="100"
                        data-qa="goal-id"
                    >
                        <template slot-scope="goal">
                            <span>
                                {{ goal.id }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Funnel id"
                        width="100"
                        data-qa="goal-funnel-id"
                    >
                        <template slot-scope="goal">
                            <span :title="goal.funnelId">
                                {{ goal.funnelId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Goal j graph id"
                        width="120"
                        data-qa="goal-j-graph-id"
                    >
                        <template slot-scope="goal">
                            <span>
                                {{ goal.goalJGraphId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Contact id"
                        width="120"
                        data-qa="goal-contact-id"
                    >
                        <template slot-scope="goal">
                            <span>
                                {{ goal.contactId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Meta data"
                        width="150"
                        data-qa="goal-meta-data"
                    >
                        <template slot-scope="goal">
                            <span>
                                {{ goal.metaData }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Date created"
                        width="170"
                        data-qa="goal-date-created"
                    >
                        <template slot-scope="goal">
                            <span>
                                {{ goal.dateCreated }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Last updated"
                        width="170"
                        data-qa="goal-last-updated"
                    >
                        <template slot-scope="goal">
                            <span>
                                {{ goal.lastUpdated }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
            <div v-if="!noResultsToDisplay">
                <p class="no-details-label">
                    No results to display
                </p>
            </div>
        </template>
    </section>
</template>

<script>
export default {
    props: {
        goalAchievedList: Array,
    },

    computed: {
        noResultsToDisplay() {
            return this.goalAchievedList?.length > 0;
        },
    },
};
</script>
<style lang="scss" scoped>
    .grid-container {
        margin: $spacing-250 0;
        display: flex;
    }

    .profile-label {
        margin: auto;
        font-size: 1.75rem;
        color: $color-text;
    }

    .table-scroller {
        overflow:auto;
        white-space: nowrap;
    }

    @media only screen and ($medium) {
        .grid-container {
            margin-top: 1.875rem;
            display: block;
        }
    }

    .stealth-goal-achieved {
        display: grid;
    }

    .no-details-label {
        color: $color-gray-darker;
        font-size: $font-size-lg;
        font-weight: 300;
        padding-top: $spacing-400;
    }
</style>
